var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center flex-none w-auto mb-0 font-medium rounded-full text-gray-700 bg-gray-100 px-1.5 py-2.5",style:({
    paddingTop: _vm.isMobile ? '0.125rem' : '0.375rem',
    paddingBottom: _vm.isMobile ? '0.125rem' : '0.375rem',
    paddingLeft: _vm.isMobile ? '0.5rem' : '0.625rem',
    paddingRight: _vm.isMobile ? '0.5rem' : '0.625rem',
  })},[_c('p',{staticClass:"block m-0 ds-text-2xs md:ds-text-xs"},[_vm._v(_vm._s(_vm.genderPossessiveForm)+" "+_vm._s(_vm.sport))])])
}
var staticRenderFns = []

export { render, staticRenderFns }